module.exports = __webpack_public_path__ + "img/exam_jan_2025_krp4gf13.0dddc270.jpg";